import React, { useEffect, useState } from 'react';

const API_BASE = 'https://referee-roster-api-v2-hqghffesdfegd2dq.australiaeast-01.azurewebsites.net/api';
const th = { textAlign: 'left', padding: '0.4rem 0.6rem', fontWeight: 600, color: '#555', whiteSpace: 'nowrap' };
const td = { padding: '0.4rem 0.6rem', verticalAlign: 'top' };

// A participant's Swish IQ trial history (read-only): each session they are in, with their
// number, selection status, team(s) and how many feedback notes they have there.
export default function ParticipantSwishSessions({ participantId }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!participantId) return undefined;
    let cancelled = false;
    setRows(null);
    setError('');
    fetch(`${API_BASE}/participants/${participantId}/swish-sessions`)
      .then(async (r) => {
        const data = await r.json().catch(() => []);
        if (!r.ok) throw new Error(data.error || `HTTP ${r.status}`);
        return data;
      })
      .then((data) => { if (!cancelled) setRows(Array.isArray(data) ? data : []); })
      .catch((e) => { if (!cancelled) setError(e.message); });
    return () => { cancelled = true; };
  }, [participantId]);

  return (
    <div className="form-group" style={{ gridColumn: '1 / -1' }}>
      <label>SwishIQ Trials</label>
      {error && <div style={{ color: '#c62828', fontSize: '0.85rem' }}>{error}</div>}
      {!error && rows === null && <div style={{ color: '#888', fontSize: '0.85rem' }}>Loading…</div>}
      {rows && rows.length === 0 && (
        <div style={{ color: '#888', fontSize: '0.85rem' }}>Not in any SwishIQ Trials session yet.</div>
      )}
      {rows && rows.length > 0 && (
        <div style={{ overflowX: 'auto', border: '1px solid #eee', borderRadius: 6 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.82rem' }}>
            <thead>
              <tr style={{ background: '#fafafa' }}>
                <th style={th}>Session</th>
                <th style={th}>Date</th>
                <th style={th}>#</th>
                <th style={th}>Status</th>
                <th style={th}>Team</th>
                <th style={th}>Notes</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={`${r.eventId}-${r.date}-${i}`} style={{ borderTop: '1px solid #f0f0f0' }}>
                  <td style={td}>{r.eventName}{r.trialYear ? ` (${r.trialYear})` : ''}</td>
                  <td style={td}>{r.date ? new Date(`${r.date}T00:00:00`).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : '–'}</td>
                  <td style={td}>{r.number ?? '–'}</td>
                  <td style={td}>{r.status || '–'}</td>
                  <td style={td}>{r.teams.length ? r.teams.join(', ') : '–'}</td>
                  <td style={td}>{r.notes || '–'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
